import React, { useState } from "react";
import styled from "styled-components";
import { compose } from "redux";
import { withRouter } from "react-router";

import { CardButtonFilled } from "../../../components/Admin/AppsSettings/CardStyles";

import AuthPin from "./AuthPin";

const DEFAULT_PIN_LENGTH = 6;

const StyledButton = styled(CardButtonFilled)`&& {
  background: ${({ pin }) => (pin.length === DEFAULT_PIN_LENGTH ? "#005AA9" : "#C4C4C4")};
  width: 262px;
  height: 48px;
  border: none;
  margin-top: 10px;
}`;

const PinError = styled.span`
  padding-left: 20px;
  color: red;
`;

const LenderViewAuth = ({ refreshDataWithPin, showPinError }) => {
  const [pin, setPin] = useState(0);
  const handleSubmit = () => refreshDataWithPin(pin);
  const handleOnChange = pinInput => setPin(pinInput);

  return (
    <div>
      <p>Please enter the PIN found in your email to access this secure content</p>
      <div style={{ display: "flex" }}>
        <div>
          <AuthPin onChange={handleOnChange} />
        </div>
        <div style={{ marginTop: 15 }}>
          {showPinError && <PinError>Incorrect PIN</PinError>}
        </div>
      </div>
      <StyledButton disabled={`${pin}`.length !== DEFAULT_PIN_LENGTH} onClick={handleSubmit} pin={pin}>
        Unlock Report
      </StyledButton>
    </div>
  );
};

export default compose(withRouter)(LenderViewAuth);
